import { HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PnToastService } from '@privanot/shared-ui/primeng-acl/toast';
import { catchError, throwError } from 'rxjs';
import { extractProblemDetail } from '@admin/shared/http/extract-error-detail';
import { SUPPRESS_ERROR_TOAST } from '@admin/shared/http/suppress-error-toast.token';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const injector = inject(Injector);

    return next(req).pipe(
        catchError((error) => {
            if (req.context.get(SUPPRESS_ERROR_TOAST)) {
                return throwError(() => error);
            }

            const toastService = injector.get(PnToastService);
            const translateService = injector.get(TranslateService);
            const detail = extractProblemDetail(error) ?? translateService.instant('general.toast.unknownError');

            toastService.show({ severity: 'error', summary: translateService.instant('general.toast.error'), detail });

            return throwError(() => error);
        }),
    );
};
